// extracted by mini-css-extract-plugin
export default {"icon":"src-components-status-icon-styles_icon","glow":"src-components-status-icon-styles_glow","balloon":"src-components-status-icon-styles_balloon"};